/* ==========================================================================
   Portal Not Found Page
   Task F19: Shown when portal slug is invalid or portal doesn't exist
   ========================================================================== */

import { Link, useParams } from 'react-router-dom'
import { Card } from '@/components/ui/Card'
import { Button } from '@/components/ui/Button'
import { Building2 } from 'lucide-react'

export function PortalNotFound() {
  const { slug } = useParams<{ slug: string }>()

  return (
    <div className="flex min-h-screen items-center justify-center bg-warm-beige p-4">
      <Card className="w-full max-w-md">
        <div className="text-center">
          <div className="flex justify-center mb-4">
            <Building2 className="h-16 w-16 text-charcoal/30" />
          </div>
          <h1 className="font-serif text-2xl text-charcoal mb-2">
            Portal Not Found
          </h1>
          <p className="text-charcoal/70 mb-2">
            We couldn't find a pharmacy portal at this address.
          </p>
          {slug && (
            <p className="text-sm text-charcoal/50 mb-6 font-mono">/rx/{slug}</p>
          )}
          <p className="text-sm text-charcoal/60 mb-6">
            Please check the URL and try again, or contact your pharmacy for the
            correct portal link.
          </p>
          <div className="space-y-3">
            <Link to="/" className="block">
              <Button variant="primary" className="w-full">
                Go to Home
              </Button>
            </Link>
            <Link to="/admin/signup" className="block">
              <Button variant="secondary" className="w-full">
                Create a Pharmacy Portal
              </Button>
            </Link>
          </div>
        </div>
      </Card>
    </div>
  )
}

export default PortalNotFound
